
























import { generateTemplateOptions } from '@/utils/todo';
import { Component, Prop, Vue } from 'vue-property-decorator';

type ITodoTemplateInfo = IModule.IResponse.ITodoTemplateInfo;

const titleColumm = {
  slots: { title: 'todoTitle' },
  dataIndex: 'title',
  ellipsis: true,
};
const manDayColumn = {
  slots: { title: 'manDayTitle' },
  dataIndex: 'manDay',
  width: '10%',
  align: 'center',
  sorter: (a: ITodoTemplateInfo, b: ITodoTemplateInfo) => a.manDay - b.manDay,
};
const descriptionColumm = {
  slots: { title: 'descriptionTitle' },
  dataIndex: 'description',
  ellipsis: true,
};

@Component({
  components: {},
})
export default class TemplateTodoListModal extends Vue {
  @Prop({required: true}) private todoList!: ITodoTemplateInfo[];
  @Prop({default: () => ([])}) private defaultSelectIds!: string[];
  private visible = false;
  private selectedKeys: string[] = [...this.defaultSelectIds];
  private selectedTodos: ITodoTemplateInfo[] = [];
  get columns() {
    const { typeOption, settlementUnitOption } = generateTemplateOptions(this.todoList);
    const typeColumn = {
      slots: { title: 'typeTitle' },
      dataIndex: 'typeName',
      scopedSlots: { customRender: 'typeId' },
      width: '20%',
      ellipsis: true,
      filters: typeOption,
      onFilter: (value: string, record: ITodoTemplateInfo) => {
        return record.typeId === value;
      },
    };
    const settlementUnitColumn = {
      dataIndex: 'settlementConfigurationName',
      slots: { title: 'settlementUnitTitle' },
      width: '15%',
      align: 'center',
      filters: settlementUnitOption,
      onFilter: (value: string, record: ITodoTemplateInfo) => record.settlementConfigurationId === value,
    };
    return [
      titleColumm,
      typeColumn,
      manDayColumn,
      settlementUnitColumn,
      descriptionColumm,
    ];
  }
  get templateRowSelection() {
    return {
      onChange: (selectedRowKeys: string[], selectedRows: ITodoTemplateInfo[]) => {
        this.selectedKeys = selectedRowKeys;
        this.selectedTodos = selectedRows;
      },
      selectedRowKeys: [...this.selectedKeys],
    };
  }
  public showModal() {
    this.visible = true;
  }
  public closeModal() {
    this.visible = false;
    this.selectedKeys = [];
  }
  public handleSubmit() {
    this.$emit('change', this.selectedTodos);
    this.closeModal();
  }
}
